<template>
  <div class="athome" style="background-color:white; margin:10px; padding:10px;">
    <div style="height:60px"></div>
    <div class="text-center">
      <img src="/img/athomelogo.png" alt width="100px" />
    </div>
    <div style="height:10px"></div>

    <h2>
      <span style="background-color:#fff">プロの演奏で歌ってみた動画をつくってみよう。</span>
    </h2>
        <iframe
      width="560"
      height="315"
      src="https://www.youtube.com/embed/LrhTryTOE3g"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    <p>
      J-POP JAMのホストメンバーがアップするJ-POPスダンダード曲のバック演奏にあわせて、YOUTUBE、インスタグラム等にコラボ動画を自由にアップロードしてください。
      <br />
      <br />アップしたら
      #jpopjamのハッシュタグをつけてもらえれば、J-POP JAMのツイッターアカウントでシェアなどもいたします。
    </p>

    <ul
      class="pl-0 m-4"
      style="list-style: none; padding: initial; background-color:#FFFFFF; text-align:center;"
    >
    <h2> -参加方法- </h2>
    <h2> ①動画を撮影。</h2>
<p>こちらの伴奏動画をイヤホンで聴きながら、別のスマホなどで自分のパフォーマンス動画を撮影。動画素材はダウンロードも可能。</p>

      <li>
        <p>丸の内サディスティック</p>
        <video
          src="https://firebasestorage.googleapis.com/v0/b/jpopjam0813.appspot.com/o/athome%2F%E4%B8%B8%E3%81%AE%E5%86%85%E3%82%B5%E3%83%86%E3%82%99%E3%82%A3%E3%82%B9%E3%83%86%E3%82%A3%E3%83%83%E3%82%AF%E6%98%A0%E5%83%8F%E7%B4%A0%E6%9D%90.mov?alt=media&token=9f300659-6149-476e-812d-e435260b2844"
          controls
          width="300px"
        ></video>
              </li>
      <li>
       <base-button onclick="location.href='https://www.dropbox.com/sh/uy49iti2p9en3ah/AABvbS37zvl_qNtXJZWTUJzda?dl=0'">DropBox</base-button>

      </li>
      <li>
        <p>I LOVE YOU</p>
        <video
          src="https://firebasestorage.googleapis.com/v0/b/jpopjam0813.appspot.com/o/athome%2FiLoveyou%E5%B0%BE%E5%B4%8E%E6%98%A0%E5%83%8F%E7%B4%A0%E6%9D%90.mov?alt=media&token=f1aa49fc-31d3-450b-95e8-9fbaec66a137"
          controls
          width="300px"
        ></video>
              </li>
      <li>
        <base-button onclick="location.href='https://www.dropbox.com/sh/utoown7mgtmj5me/AADGQB2lNkJOjPRZN3aRbfCRa?dl=0'">DropBox</base-button>
      </li>

       <li>
        <p>Pretender</p>
        <video
          src="https://firebasestorage.googleapis.com/v0/b/jpopjam0813.appspot.com/o/athome%2F%E4%B8%B8%E3%81%AE%E5%86%85%E3%82%B5%E3%83%86%E3%82%99%E3%82%A3%E3%82%B9%E3%83%86%E3%82%A3%E3%83%83%E3%82%AF%E6%98%A0%E5%83%8F%E7%B4%A0%E6%9D%90.mov?alt=media&token=9f300659-6149-476e-812d-e435260b2844"
          controls
          width="300px"
        ></video>
              </li>
      <li>
       <base-button onclick="location.href='https://www.dropbox.com/sh/9udykidoh0xrmcr/AADUviZOPCa3WaZTwE4vmB64a?dl=0'">DropBox</base-button>

      </li>
      <li>
        <p>カブトムシ</p>
        <video
          src="https://firebasestorage.googleapis.com/v0/b/jpopjam0813.appspot.com/o/athome%2FiLoveyou%E5%B0%BE%E5%B4%8E%E6%98%A0%E5%83%8F%E7%B4%A0%E6%9D%90.mov?alt=media&token=f1aa49fc-31d3-450b-95e8-9fbaec66a137"
          controls
          width="300px"
        ></video>
              </li>
      <li>
        <base-button onclick="location.href='https://www.dropbox.com/sh/xzxvg3j8dtx36yo/AADLLiynV_04w8k0bn40PQGua?dl=0'">DropBox</base-button>
      </li>

    </ul>
  
    <h2>
      <span style="background-color:#fff">②映像編集はできなくてもOK。</span>
    </h2>
    <p>動画の編集なんてやったことない？？自分のパフォーマンス動画だけ下記のフォームから送っていただければ、J-POP JAM TEAMで編集も可能です。お問い合わせなど下記メールまで。</p>
    <a href="mailto:jpopjam0412@gmail.com">jpopjam0412@gmail.com</a>
  <div style="padding:5px;">
      <h2　style="padding:10px;">動画送信フォーム </h2>
      <p>アーティスト名</p>
      <input type="text" v-model="name" style="margin:10px;" />
      <br />
      <p>Emailアドレス　*間違いにお気をつけください。</p>
      <input type="text" v-model="email" 　style="margin:10px;" />

      <p>動画ファイル</p>
      <input type="file" multiple="multiple" name="file" @change="itemImageUpload" style="margin:10px;" />
      <a v-if="nowUpload">アップロード中      <img src="/img/loder1.gif" alt width="20px" />
</a>
      <a v-if="uploadState">{{uploadState}}:</a>
      <a v-if="uploadState=='success'">ご応募ありがとうございました。担当からの数日以内にご連絡いたします。</a>

    <video :src="backgroundImage" width="50%" style="margin:10px;" />
  <div style="padding:15px;">

   <base-button @click="setFile">この内容で送信</base-button>
    </div>


    </div>
    <div style="padding:10px;"></div>
    <h2>
      <span style="background-color:#fff">距離も時間も超えて、音楽でつながろう。</span>
    </h2>
    <p>みんなで同じ時間空間を共有し一緒に演奏する、というリアルイベントでの体験はかけがえのないもの。でもインターネットを通じて物理的制約を超えてもっと多くの人たちと繋がることができる。リアルでもオンラインでも、音楽を通して繋がる気持ち伝わる思いはきっと同じ。</p>

  </div>
</template>


<script>
import firebase from "firebase/app";

export default {
  name: "event",

  data() {
    return {
      nowJoinSession: {},
      trackList: {},
      name: "",
      email: "",
      result: "",
      backgroundImage: "",
      nowUpload: false,
      uploadState: null,
      file:""
    };
  },
  computed: {
    nowJoinSessionInfo() {
      return this.$store.state.nowJoinSessionInfo;
    }
  },
  created() {
    firebase
      .database()
      .ref("eventList/")
      .on("value", snapshot => {
        var eventList = snapshot.val();
        this.nowJoinSession = eventList[this.nowJoinSessionInfo];
        const MarkdownIt = require("markdown-it");
        const meta = require("markdown-it-meta");
        const md = new MarkdownIt();
        md.use(meta);
        const result = md.render(this.nowJoinSession.eventDetail);
        this.result = result;
      });

    firebase
      .database()
      .ref("trackList/")
      .on("value", snapshot => {
        this.trackList = snapshot.val();
      });
  },
  methods: {
    thumbUrl(id) {
      return "http://img.youtube.com/vi/" + id + "/mqdefault.jpg";
    },
    itemImageUpload(e) {
        var file_name;
        e.preventDefault();
        this.file = e.target.files||e.dataTransfer.files;
        this.backgroundImage=window.URL.createObjectURL(this.file[0]);
      },
      setFile(){
      if (this.email == "" || this.name == ""|| this.file=="") {
        alert("全てを登録してください。");
      } else {
        const storage = firebase.storage();
        this.nowUpload = true;
        var file_name = this.file[0].name;
        var blob;
        blob = new Blob(this.file);
        var uploadRef = storage
          .ref("athome/" + this.name + "_" + this.email + "/")
          .child(file_name);
        uploadRef.put(blob).then(snapshot => {
          this.uploadState = snapshot.state;
          uploadRef
            .getDownloadURL()
            .then(url => {
              this.backgroundImage = url;
              this.nowUpload = false;
            })
            .catch(error => {
              console.log(error);
            });
        });
        // valueリセットする
        file_name = "";
        blob = "";  }
    },
    alt() {
      window.alert("外部サイトへ飛びます");
    }
  }
};
</script>

<style>
</style>